import { httpsCallable } from 'firebase/functions';
import { functions } from '../Firebase';

export type ExportFormat = 'csv' | 'json';
export type LeadType = 'leads' | 'partialLeads';

export interface ExportLeadsParams {
  accountId: string;
  startDate: string;
  endDate: string;
  type: LeadType;
  dynamicPageIds?: string[];
  format?: ExportFormat;
}

export interface ExportLeadsResponse {
  ok: boolean;
  jobId: string;
  fileName: string;
}

export async function exportLeads(
  params: ExportLeadsParams,
): Promise<ExportLeadsResponse> {
  const fn = httpsCallable<ExportLeadsParams, ExportLeadsResponse>(
    functions,
    'leads/exportLeads',
  );

  const response = await fn(params);
  return response.data;
}
